export default __webpack_public_path__ + "static/media/LINH.d8a04373.jpg";